
export default {
  install(editor, options) {
    editor.on('connectioncreated', (connection) => {
      const node = connection.output.node
      if (options.name && options.either && options.or) {
        if (options.name === node.name) {
          const connectionKey = connection.output.key
          let hasConnections = []
          if (connectionKey === options.either) {
            hasConnections = node.outputs.get(options.or).connections.slice()
          } else if (connectionKey === options.or) {
            hasConnections = node.outputs.get(options.either).connections.slice()
          }

          if (hasConnections.length > 0) {
            hasConnections.forEach(singleConnection => {
              editor.removeConnection(singleConnection)
            })
          }
        }
      }
    })
  }
}